<script>
import resources from './resources'
import '@desislavsd/vue-select/dist/vue-select.css'

export default {
  name: 'unit-form',
  mixins: [resources]
}
</script>

<template lang="pug">
  section.content
    .container-fluid
      .block-header
        .row
          .col-lg-5.col-md-5.col-sm-12
            h2 Empréstimo de vagas
            ul.breadcrumb.padding-0
              li.breadcrumb-item
                a(href='index.html')
                  i.zmdi.zmdi-home
              li.breadcrumb-item
                a(href='javascript:void(0);') Empréstimo de vagas
              li.breadcrumb-item.active Cadastro
          //-.col-lg-7.col-md-7.col-sm-12
            .input-group.m-b-0
              input.form-control(
                type='text',
                placeholder='Localizar Unidade',
                disabled
              )
              span.input-group-addon
                i.zmdi.zmdi-search


      .row.clearfix
        .col-lg-12
          .card
            .header
              ul.header-dropdown
                li.dropdown(:class="{'show': show}")
                  a.dropdown-toggle(@click.prevent="showActions(show)", href='javascript:void(0);')
                    i.zmdi.zmdi-more
                  ul.dropdown-menu.dropdown-menu-right(:class="{'show': show}")
                    li
                      router-link(:to="{name: 'dweller.parking.index'}") Listagem
                    li
                     router-link(:to="{name: 'dweller.parking.create'}") Cadastro
            .body
              h2.card-inside-title
               .row.clearfix
                  .col-lg-4.col-md-4
                    .form-group
                      v-input(:status="$v.parking.tower_id.$error ? 'error' : null")
                        f-select(
                          id="unit_id",
                          name="tower",
                          track-by="id",
                          label-by="number",
                          v-model="parking.tower_id",
                          :options="dwellerTowers",
                          :searchable="true",
                          :multiple="false",
                          placeholder='Sua Torre',
                          @selected ="selectUnitsTower"
                          openDirection="bottom"
                        )

                  .col-lg-4.col-md-4
                    .form-group
                      v-input(:status="$v.parking.unit_id.$error ? 'error' : null")
                        f-select(
                          id="unit_id",
                          name="Unidade",
                          track-by="id",
                          placeholder="Sua Unidade"
                          label-by="number",
                          v-model="parking.unit_id",
                          :options="dwellerUnits",
                          :searchable="true",
                          :multiple="false",
                          @selected="getGaragesDweller"
                          openDirection="bottom"
                        )
                  .col-lg-4.col-md-4(v-if="user.parking_space_for_visitors")
                    v-input(:status="$v.parking.garage_number_visitor.$error ? 'error' : null")
                      f-select(
                        id="garage_number",
                        placeholder="Garagem"
                        track-by="id",
                        label="Garage Número",
                        label-by="label",
                        v-model="parking.garage_number_visitor",
                        :options="visitorGarages",
                        :searchable="true",
                        :multiple="false",
                        openDirection="bottom"
                      )
                  .col-lg-4.col-md-4(v-else)
                    .form-group
                      v-input(:status="$v.parking.garage_id.$error ? 'error' : null")
                          f-select(
                            id="garage_id",
                            placeholder="Garagem"
                            track-by="id",
                            label="Garage (Selecine uma Unidade)",
                            label-by="number",
                            v-model="parking.garage_id",
                            :options="garages",
                            :searchable="true",
                            :multiple="false",
                            openDirection="bottom"
                          )
              h2.card-inside-title Dados do Carro
              .row.clearfix
                .col-lg-4.col-md-4
                  .form-group
                   v-input(:status="$v.parking.plate.$error ? 'error' : null")
                      input.form-control(
                        type='text',
                        placeholder='Placa'
                        v-model="parking.plate"
                      )
                .col-lg-4.col-md-4
                  .form-group
                    v-input(:status="$v.parking.model.$error ? 'error' : null")
                      input.form-control(
                        type='text',
                        placeholder='Modelo',
                        v-model="parking.model"
                      )
                .col-lg-4.col-md-4
                  .form-group
                    v-input(:status="$v.parking.color.$error ? 'error' : null")
                      input.form-control(
                        type='text',
                        placeholder='Cor',
                        v-model="parking.color"
                      )
              h2.card-inside-title Dados do Visitante
              .row.clearfix
                .col-lg-4.col-md-4
                  .form-group
                    input.form-control(
                      type='text',
                      placeholder='Nome do Visitante',
                      v-model="parking.guest_name"
                    )
                .col-lg-4.col-md-4
                  .form-group(style="margin-top: -5px;")
                    v-input(:status="$v.parking.destination_tower_id.$error ? 'error' : null")
                      f-select(
                      id="tower_id",
                      name="unidade",
                      track-by="id",
                      label-by="number",
                      placeholder="Torre Destino",
                      v-model="parking.destination_tower_id",
                      :options="optionTowers",
                      :searchable="true",
                      :multiple="false",
                      openDirection="bottom"
                    )

                .col-lg-4.col-md-4
                  .form-group(style="margin-top: -5px;")
                    v-input(:status="$v.parking.destination_unit_id.$error ? 'error' : null")
                      f-select(
                        id="unit_id",
                        track-by="id",
                        label-by="number",
                        placeholder="Unidade Destino"
                        v-model="parking.destination_unit_id",
                        :options="optionUnits",
                        :searchable="true",
                        :multiple="false",
                        openDirection="bottom"
                      )
              h2.card-inside-title Período de Empréstimo
              .row.clearfix
                .col-sm-6
                  .form-group(v-if="!parking.id")
                    v-input(:status="$v.parking.date_go_in.$error ? 'error' : null")
                      label Data Inicial
                      vue-ctk-date-time-picker(
                        color="#7159c1",
                        v-model="parking.date_go_in",
                        no-label,
                        :no-header="false"
                        label="Selecione uma data"
                        :only-date="true"
                        locale="pt-br",
                        :format="'YYYY-MM-DD'",
                        :min-date="miniDate",
                        :max-date="maxDate",
                        :auto-close="true",
                        :no-keyboard="true",
                        button-now-translation="Hoje"
                      )
                  .form-group(v-if="parking.id")
                    v-input(:status="$v.parking.date_go_in.$error ? 'error' : null")
                      label Data Inicial
                      input.form-control(
                        name="date_go_in",
                        v-model="parking._edit_date_go_in",
                        disabled
                      )
                .col-sm-6
                  .form-group(v-if="!parking.id")
                    v-input(:status="$v.parking.date_go_out.$error ? 'error' : null")
                      label Data Final (Período maximo 7 dias)
                      vue-ctk-date-time-picker(
                        color="#7159c1",
                        v-model="parking.date_go_out",
                        no-label,
                        :no-header="false"
                        label="Selecione uma data"
                        :only-date="true"
                        locale="pt-br",
                        :format="'YYYY-MM-DD'",
                        :min-date="miniDate",
                        :max-date="maxDate",
                        :auto-close="true",
                        :no-keyboard="true",
                        button-now-translation="Hoje",
                        @input="validityDate"
                      )
                  .form-group(v-if="parking.id")
                    v-input(:status="$v.parking.date_go_out.$error ? 'error' : null")
                      label Data Final (Período maximo 7 dias)
                      input.form-control(
                        type="text",
                        name="go_in_out",
                        v-model="parking._edit_date_go_out",
                        disabled
                      )
                .col-lg-12.col-md-12(v-if="user.tenant_id === '29G85GQ'")
                  .alert.alert-warning(style="color: #333; text-align: justify;text-justify: inter-word;")
                    strong Atenção!  &nbsp;
                    | 1- O Síndico não tem autonomia para autorizar entradas de veículos não cadastrados no sistema, conforme já explanado em Assembleia Geral Extraordinária;
                    | 2- A equipe da Central de Vigilância não irá autorizar acessos ao estacionamento através de ligações em que seja comunicado que a Síndica autorizou a entrada, pois as regras estão definidas em Assembleia Geral Extraordinária, e estas são de conhecimento geral de todos os condôminos;
                    | 3- Ressalta-se que a responsabilidade por acesso de terceiros ou empréstimo de vagas são de inteira responsabilidade do CEDENTE.
                    | 4- Sugerimos que os condôminos que tem veículos de terceiros que adentram ao condomínio realizem o cadastro no APP e adquiram a TAG adicional para fins de facilitação de acesso sem a entrega de termo. Cada TAG adicional custa R$ 22,00 (vinte e dois reais) até o mês de novembro/2017.
                    br
                    strong Importante ressaltar que o portão somente se abrirá se não estiver nenhum veículo vinculado a sua vaga estacionado, &nbsp;
                    strong Declaro ser responsável civil e criminalmente por qualquer ato realizado pelo CESSIONÁRIO no período de uso e gozo do empréstimo aqui confirmado e assinado por mim.

                .col-md-12
                    button.btn.btn-raised.btn-primary.btn-round.waves-effect(
                      type='button',
                      @click.prevent="doSave()",
                    ) Salvar

</template>
<style scoped>
.color-red {
  color: #f96332;
}
</style>



// WEBPACK FOOTER //
// src/app/tenant/parking/form/form.vue